(function (angular, schoolwork12) {

'use strict';
angular.module(schoolwork12.app.graduationPlan.name)
  .controller(schoolwork12.app.graduationPlan.controllers.subjectCriteria, [
    '$scope', '$uibModal', '$uibModalInstance', 'allSubjects', 'selectedSubject',
    function ($scope, $uibModal, $uibModalInstance,allSubjects,selectedSubject) {
        console.info("inside subject criteria controller");
        /*console.info(angular.toJson(allSubjects));                                              
        console.info(angular.toJson(selectedSubject));*/

        $scope.form = {};
        $scope.allSubjectsOnModal = allSubjects;
        $scope.copiedObject= angular.copy(selectedSubject);
        $scope.selectedSubjectOnModal = $scope.copiedObject;
        //$scope.selectedSubjectOnModal = selectedSubject;
        $scope.errorOccured = false;
        if($scope.selectedSubjectOnModal.subjectCriteria != null){
            $scope.subjectCriteriaObject = $scope.selectedSubjectOnModal.subjectCriteria;
        } else {
            $scope.subjectCriteriaObject =  {"logicalOperation" : "AND",
                                             "subjectCriteriaList"  :[{
                                                                        "credits" : 0.0,
                                                                        "option"  : null,
                                                                        "index" : 0
                                                                        }]
                                            }
        }
        
        /*$scope.subjectCriteriaObject =  {
                                          "logicalOperation" : "AND",
                                          "subjectCriteriaList" : [{ "credits" : 0.0, "option"  : null }]
        };*/

        $scope.addSubjectSummary = function(){
        	$scope.errorOccured = false;
        	$scope.form.SubjectCriteria.$setValidity('noRowsExists', true);
            $scope.form.SubjectCriteria.$setDirty();                       
            var length = $scope.subjectCriteriaObject.subjectCriteriaList.length;
            var index = 0;
            if(length!=0){
                index = $scope.subjectCriteriaObject.subjectCriteriaList[length-1].index+1;
            }
            $scope.subjectCriteriaObject.subjectCriteriaList.push ({ "credits" : 0.0, "option"  : null , "index": index});                        
        };
        $scope.removeSubjectSummary = function(index){  
            $scope.form.SubjectCriteria.$setDirty();                     
            $scope.subjectCriteriaObject.subjectCriteriaList.splice(index,1);
        };

        //reset input field for 0 credits
        $scope.credit_focus = function(subject){
            if(subject.credits==0){
                subject.credits = '';
            }
        }
        $scope.credit_blur = function(subject){
           if(subject.credits=='' || subject.credits==null){
               subject.credits = 0;
           }
        }

        
        $scope.cancel = function () {
            if($scope.form.SubjectCriteria.$dirty){
                $scope.openAlertUnsaved($uibModalInstance);
            } 
            else{
              $uibModalInstance.dismiss('cancel');
            }           
        };

        //display unsaved changes modal
        $scope.openAlertUnsaved = function (modalInstance) {
          var modalInstance1 = $uibModal.open({
              animation: $scope.animationsEnabled,
              templateUrl: 'dialog.html',
              windowClass: 'alert-Modal',
              keyboard: false,
              backdrop: 'static',
              controller: ['$scope', '$uibModalInstance',
              function ($scope, $uibModalInstance) {
                  $scope.yes = function () {
                      modalInstance.dismiss('cancel');
                      $uibModalInstance.dismiss('cancel');
                  };

                  $scope.dialogMsg = 'You have un-saved changes on the current page. Do you want to continue without saving the changes?';
                  $scope.no = function () {
                      $uibModalInstance.dismiss('cancel');
                  };
              }], 
              
          });
        };
        
        $scope.ok = function () {
        	if($scope.validateSubjectCriteria()){
                if($scope.form.SubjectCriteria.$dirty)
                    $scope.subjectCriteriaObject.dirty = true;
            	$uibModalInstance.close($scope.subjectCriteriaObject);
        	}
        };  

        //validations for subject criteria
        $scope.validateSubjectCriteria = function(){
        	var subjectSet = {};
        	$scope.errorOccured = false;
            var validationSuccess = true;
            var subjectNotProvided=false;
            $scope.form.SubjectCriteria.$setValidity('noRowsExists', true);
            if($scope.subjectCriteriaObject.subjectCriteriaList.length==0)
          	  {
              $scope.errorOccured = true;	
          	  validationSuccess =false;
          	  $scope.form.SubjectCriteria.$setValidity('noRowsExists', false);
          	  }
            angular.forEach($scope.subjectCriteriaObject.subjectCriteriaList, function(subject){
	          	 if(subject.option == null){
	          		$scope.errorOccured = true;
	          		 validationSuccess =false;
	          		 $scope.form.SubjectCriteria['subject_'+subject.index].$setValidity('subjectRequired', false);
	                  }
	                  else{
	                	  $scope.form.SubjectCriteria['subject_'+subject.index].$setValidity('subjectRequired', true);
	                }
	          	 if(subject.credits != null && angular.isNumber(subject.credits)){
	          		if(!(subject.credits<100.0&&subject.credits>=0.0)){
	          				$scope.errorOccured = true;
		          			validationSuccess =false;
		          			$scope.form.SubjectCriteria['credit_'+subject.index].$setValidity('invalidCredit', false);
	          			} else {
		          		   	  $scope.form.SubjectCriteria['credit_'+subject.index].$setValidity('invalidCredit', true);
		               }
		          	 }
		            else{
		                $scope.form.SubjectCriteria['credit_'+subject.index].$setValidity('invalidCredit',false);
		            }
	          	 
                 if(subject.option && subjectSet[subject.option.name+'/'+subject.option.schoolSubjectId+'/'+subject.option.k12SubjectId]){
       				$scope.errorOccured = true;
          			validationSuccess =false;
          			$scope.form.SubjectCriteria['subject_'+subject.index].$setValidity('duplicateSubject', false);
                 } else {
                	$scope.form.SubjectCriteria['subject_'+subject.index].$setValidity('duplicateSubject', true);
                 }
                 
                 if(subject.option){
                     subjectSet[subject.option.name+'/'+subject.option.schoolSubjectId+'/'+subject.option.k12SubjectId] = 1;
                 }
            });
            
            
            return validationSuccess; 
          };

        
        $scope.validateSubjectCriteriaTotal = function(){
            return true;
        };
        
        $scope.validateSubjectCriteriaCredits = function(){
            
            return true;
        };
                
    }]);
}(angular, schoolwork12));